import WatchSuggestionListContainer from './WatchSuggestionList.container';
import WatchSuggestionList from './WatchSuggestionList';
export default WatchSuggestionListContainer(WatchSuggestionList);
